<template>
  <div>
    <div class="section-right-content-box">
      <div class="box-shadow top-box">
        <div class="global-title">
          金额分析
        </div>
      </div>
      <div style="padding: 20px">
        <!-- 查询条件 -->
        <div style="margin:6px 0 0 5px;">
          <el-form >
            <el-form-item>
              <el-radio
                v-model="queryForm.evaluateTime"
                @change="timeChange"
                v-for="item in options.evaluateTimeOpt"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
              <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="postForm.startDate"
            type="datetime"
            :picker-options="pickerOptionsStart"
            :placeholder="'选择日期时间'"
            size="small"
            :disabled="  queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px;font-size:12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text" :class="{'to_text_disabled': queryForm.evaluateTime != 0 || !queryForm.evaluateTime}">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="postForm.endDate"
            type="datetime"
            :placeholder="'选择日期时间'"
            :picker-options="pickerOptionsEnd"
            size="small"
            :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px;font-size:12px"
            class="time2"
            :clearable="true"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
              <el-button
                style="margin-left:8px;"
                class="b1"
                v-zoom='{from:"售后中心-金额分析",name:"查询"}'
                @click="query()"
                ><span style="marginLeft:4px;"> <i
            class="el-icon-search"
            style="display:inline-block;width:14px;height:12px;margin-right:4px;"
          ></i>查询</span></el-button
              >
              <el-button
                style="margin-left:20px;"
                class="b2"
                @click="queryOne()"
                ><span style="marginLeft:4px;">重置</span></el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- 提示文案 -->
        <div style="margin:26px 0 30px 0;font-size:14px;background-color:#FFFAEE;padding:10px 0">
          <!-- <el-alert
            class="alert"
            title="区间：0-1000元<=客户消费金额<100元，依次类推"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert> -->
           <img

          src="@/assets/images/new_icon_waring_yellow.png"
          style="
            display: inline-block;
            float: left;
            position: absolute;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 0px 4px 0 3px;
          "
        />
          <span style="margin-left:24px">区间：0-1000元<=客户消费金额<100元，依次类推</span>
        </div>
        <!-- 提示框 -->
        <div>
          <div
            id="order-care"
            :style="{ width: '100%', height: '400px' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { totalMoneyBuyerCount } from "@/api/analysis/monthly-report";
export default {
  name: "monthly_report",
  data() {
    return {
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "",
            label: "全部",
          },
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "30",
            label: "近一个月",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      queryForm: {
        evaluateTime: "30",
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      mytime: [],
      zxData: {
        timeFlag: [],
        buyerCount: [],
        tradeCount: [],
        payment: [],
        buyerAvgCost: [],
      },
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  mounted: function() {
    this.timeChange('30')
    this.query();
    this.$nextTick(() => {
      this.drawOrderCareBar();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    // 清除时间函数
     clearTimeSendTime(){
      this.postForm.startDate='';
      this.postForm.endDate='';
    },
    //查询
    query() {
      let self = this;
      console.log(this.postForm);
      totalMoneyBuyerCount(this.postForm)
        .then((res) => {
          self.zxData.timeFlag = [];
          self.zxData.buyerCount = [];
          self.zxData.tradeCount = [];
          res.data.forEach((val, index) => {
            self.zxData.timeFlag.push(val.range); //时间段日期
            self.zxData.buyerCount.push(val.memberCount); //会员数
            self.zxData.tradeCount.push(val.buyTotalCount); //订单数
          });
          self.drawOrderCareBar();
        })
        .catch(() => {});
    },
    //重置
    queryOne() {
      this.queryForm.evaluateTime = "";
      this.postForm.startDate = "";
      this.postForm.endDate = "";
      this.query();
    },
    //时间限制
    timeChange(type) {
      let self = this;
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      if (type == 7) {
        this.postForm.startDate = this.mytime[0];
        this.postForm.endDate = this.mytime[1];
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = this.mytime[0];
        this.postForm.endDate = this.mytime[1];
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    //绘制柱状图
    drawOrderCareBar() {
      let self = this;
      let orderCareBarChartOne = this.$echarts.init(
        document.getElementById("order-care"),
        "light"
      ); //初始化echats实例
      orderCareBarChartOne.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        
          },
          barWidth:20
        },
        legend: {
          data: ["会员数", "订单数"],
          left: 130,
          top: 1,
          itemWidth: 8,
          itemHeight: 8,
          icon: "circle",
        },
        xAxis: {
          // x轴
          type: "category",
          name: "金额区间",
          data: self.zxData.timeFlag,
        },
        yAxis: {
          // y轴
          type: "value",
           axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            name: "会员数",
            data: self.zxData.buyerCount,
            type: "bar",
            smooth: true,
            color: ["#4CDFC0"],
            stack: "总量",
            barWidth: 20,
          },
          {
            name: "订单数",
            data: self.zxData.tradeCount,
            type: "bar",
            smooth: true,
            stack: "总量",
            color: ["#4878FF"],
            barWidth: 20,
          },
        ],
      });
      window.onresize = function() {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  /deep/{
    .el-radio__label {
    font-size: 14px;
    padding-left: 8px;
}
  }
.section-right-content-box {
  min-width: 1066px;
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;
  .echarts {
    width: 100%;
    height: 40px;
    background: #fafafa;
    opacity: 1;
    padding-left: 20px;
    line-height: 40px;
  }
  .b1{
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45 ;
      background-color: #fff;
   &:hover{
      color: #fff ;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .b2{
    width: 98px;
      height: 32px;
      color: #666666;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
    &:hover{
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
    }
  }
  .clos {
    width: 100%;
    height: 310px;
    background: #ffffff;
    border: 1px solid #f3f4f7;
    opacity: 1;
    padding-left: 20px;
  }
}
</style>
